import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import _e from 'common/localeUtil';
import GenericDialog from './GenericDialog';

const ConfigureEbookIntroductionDialog = ({ open, handleClose, handleConfirmAction }) => {
	return (
		<GenericDialog
			content={<Typography variant="body1">{_e('ebook_intro_page_desc')}</Typography>}
			confirmAction={handleConfirmAction}
			handleClose={handleClose}
			open={open}
			title={_e('ebook_intro_page')}
			confirmLabel={_e('customize_ebook_intro_page')}
		/>
	);
};

ConfigureEbookIntroductionDialog.propTypes = {
	open: PropTypes.bool,
	handleClose: PropTypes.func,
	handleConfirmAction: PropTypes.func,
};

export default ConfigureEbookIntroductionDialog;
